import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Input,
  Upload,
  message,
  Select,
  Col,
  Row,
  Tooltip,
  FloatButton,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import TickIcon from "../../Icons/TickIcon";
import { css, keyframes } from "@emotion/css";
import { contactSupportEmailAction } from "../../store/action/admin/settingAction";
import MessageQuestionIcon from "../../Theme/CustomIcons/Icons/Support,Like,Question/MessageQuestionIcon";
import PaperClipIcon from "../../Theme/CustomIcons/Icons/Type,Paragraph,Character/PaperClipIcon";
import CloseCircleIcon from "../../Theme/CustomIcons/Icons/Essetional/CloseCircleIcon";
const { TextArea } = Input;

const expand = keyframes`
  0% {
    clip-path: circle(0px at bottom right);
    display: none;
  }
  1% {
    clip-path: circle(0px at bottom right);
    display: block;
  }
  100% {
    clip-path: circle(700px at bottom right);
    display: block;
  }
`;

const collapse = keyframes`
  0% {
    clip-path: circle(700px at bottom right);
    display: block;
  }
  99% {
    clip-path: circle(0px at bottom right);
  }
  100% {
    clip-path: circle(0px at bottom right);
    display: none;
  }
`;

const popupExpand = css`
  animation: ${expand} 0.5s forwards;
`;

const popupCollapse = css`
  animation: ${collapse} 0.5s forwards;
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
`;

const cardStyle = css`
  animation: ${floatingAnimation} 3s ease-in-out infinite;
`;
const ContactUsPopup = () => {
  const contactSupportList = useSelector((state) => state.contactSupportList);
  const [showMessage, setShowMessage] = useState(false);
  const dispatch = useDispatch();
  const handleFinish = async (values) => {
    try {
      const formData = new FormData();

      formData.append("description", values.description);
      formData.append("subject", values.subject);
      formData.append("email", values.email);

      if (
        values.attachment &&
        values.attachment.fileList &&
        values.attachment.fileList.length > 0
      ) {
        values.attachment.fileList.map((e, index) => {
          formData.append(`attachment`, e.originFileObj);
        });
      }
      await dispatch(contactSupportEmailAction(formData));
      // message.success("Sent successfully!");
      form.resetFields();
      setShowMessage(true);
    } catch (err) {
      message.error("Try Again");
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      return false;
    },
  };
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const popupRef = useRef(null);
  const selectRef = useRef(null);

  const hide = () => {
    setOpen(false);
    setShowMessage(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !event.target.closest(".select-class")
      ) {
        event.preventDefault();
        hide();
      }
    };

    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const sharedUserInfo = useSelector(
    (state) => state.sharedLogin.sharedUserInfo
  );
  const themeDefault = useSelector((state) => state.themeDefault);

  return (
    <div
      className={cardStyle}
      style={{
        position: "absolute",

        bottom: "-40px",
        right: " clamp(-88px, 6vw, -100px)",
        // right: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {open && (
        <div
          ref={popupRef}
          className={
            (open ? popupExpand : popupCollapse) +
            " " +
            css`
              position: absolute;

              bottom: 20px;
              right: -20px;
              width: 340px;
              height: 566px;
              border-radius: 8px;
              background: linear-gradient(
                180deg,
                #260b3b 25.42%,
                #5a466a 36%,
                #ffffff 54.88%
              );
              padding: 16px;
              z-index: 1000;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            `
          }
        >
          <img
            style={{
              width: "100%",
              opacity: "0.30",
              position: "absolute",
              top: 0,
              left: 0,
              margin: "auto",
              display: "block",
            }}
            src="/pics/contact-support-bg.png"
          />
          <div
            style={{
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              height: 360,
              background:
                "linear-gradient(rgb(217 217 217 / 5%) 0%, rgba(115, 115, 115, 0) 100%)",
            }}
          />
          <div style={{ height: "195px", position: "relative" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                color: "white",
                alignItems: "center",
                fontSize: "20px",
                zIndex: "10",
                position: "relative",
              }}
            >
              <img src="/pics/Max_Logo_White.png" width={96} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <div>
                  <img
                    src="/pics/avatar_contact_1.png"
                    width={28}
                    style={{ position: "relative", left: 8 }}
                  />
                  <img src="/pics/avatar_contact_2.png" width={28} />
                </div>
                <div style={{ cursor: "pointer" }} onClick={hide}>
                  <CloseCircleIcon color="#fff" />
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                bottom: 8,
                width: "100%",
              }}
            >
              <h3
                style={{
                  color: "white",
                  margin: 0,
                  fontSize: "28px",
                  fontWeight: 600,
                }}
              >
                <span style={{ opacity: ".8" }}>
                  Hi
                  {/* {sharedUserInfo?.payload?.name?.firstName} */}
                </span>{" "}
                👋
              </h3>
              <h3
                style={{
                  color: "white",
                  margin: 0,
                  fontSize: "28px",
                  lineHeight: "22px",
                  marginBottom: "20px",
                  fontWeight: 600,
                }}
              >
                How can we help?
              </h3>
            </div>
          </div>
          <div
            style={{
              background: "white",
              padding: "12px",
              borderRadius: "8px",
              maxHeight: "350px",
              overflow: "auto",
              height: "100%",
              position: "relative",
            }}
          >
            {showMessage ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "100%",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <TickIcon style={{ color: "#2FD6A4", fontSize: "48px" }} />
                <p style={{ textAlign: "center" }}>
                  The form has been submitted, Our team will get back to you
                  within 24-48 hours.
                </p>
              </div>
            ) : (
              <Form
                layout="vertical"
                onFinish={handleFinish}
                form={form}
                style={{ width: "100%" }}
              >
                {" "}
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input the email!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Email" />
                </Form.Item>
                <Form.Item
                  name="subject"
                  rules={[
                    {
                      required: true,
                      message: "Please input the subject!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Enter Subject"
                    className="select-class"
                    popupClassName="select-class"
                  >
                    <Select.Option value="Help and Support">
                      Help and Support
                    </Select.Option>
                    <Select.Option value="Technical Issue">
                      Technical Issue
                    </Select.Option>
                    <Select.Option value="Feature Request">
                      Feature Request
                    </Select.Option>
                    <Select.Option value="Others">Others</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Please input the description!",
                    },
                  ]}
                >
                  <TextArea
                    style={{ resize: "none" }}
                    autoSize={false}
                    rows={2}
                    placeholder="Enter Description"
                  />
                </Form.Item>
                <Form.Item name="attachment">
                  <Upload.Dragger {...uploadProps}>
                    <PaperClipIcon /> Add up to 5 Attachments.
                  </Upload.Dragger>
                </Form.Item>
                <div>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ height: "36px" }}
                    onClick={() => form.submit()}
                    loading={contactSupportList?.loading}
                    disabled={contactSupportList?.loading}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </div>
        </div>
      )}{" "}
      <FloatButton
        shape="circle"
        // type="primary"
        // style={{
        //   right: 25,
        // }}
        className={css`
          .ant-float-btn-icon {
            width: 100% !important;
          }
          .ant-float-btn-content {
            padding: 0px !important;
          }
          .ant-float-btn-body {
            background: linear-gradient(
              200deg,
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[4]},
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[5]},
              ${themeDefault?.info?.newConfig?.colorPrimaryShades[7]}
            ) !important;
          }
          width: clamp(45px, calc(2.4vw + 21px), 60px);
          height: clamp(45px, calc(2.4vw + 21px), 60px);
        `}
        onClick={() => {
          // if (!open) {
          setOpen(!open);
          // }
        }}
        icon={
          <MessageQuestionIcon
            className={css`
              font-size: clamp(12px, 1.5vw, 24px);
              color: white !important;
            `}
            size="medium"
          />
        }
      />
      {/* <div
        style={{
          width: "85%",
          display: "flex",
          justifyContent: "center",
          fontSize: "26px",
          cursor: "pointer",
        }}
        onClick={() => {
          // if (!open) {
          setOpen(!open);
          // }
        }}
      >
        <div
          className={cardStyle}
          style={{ position: "fixed", bottom: "10px", right: "-100px" }}
        >
          <Row style={{ display: "flex", gap: "10px" }}>
            <Col>
              <Tooltip
                title={
                  <Col
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "center",
                    }}
                  >
                    <p style={{ fontSize: "11px" }}>Need Help?</p>
                    <p style={{ fontSize: "16px" }}>Contact us</p>
                  </Col>
                }
              >
                <img
                  style={{ width: "55px" }}
                  src="/pics/login/Contact_Us_Ball.png"
                />
              </Tooltip>
            </Col>
          </Row>
        </div>
      </div> */}
    </div>
  );
};

export default ContactUsPopup;
